import { MagnifyingGlassIcon, XIcon } from "@phosphor-icons/react";
import type React from "react";
import { useEffect, useState } from "react";
import { cn } from "@/core/shared/v2/lib/utils";
import { InputText, type InputTextProps } from "../form/input-text.component";

export interface SearchInputProps extends InputTextProps {
  onClearSearch?: () => void;
}

export const SearchInput = ({ value, onChange, onClearSearch, className, ...otherProps }: SearchInputProps) => {
  const [searchTerm, setSearchTerm] = useState<string>((value as string) || "");

  useEffect(() => {
    setSearchTerm((value as string) || "");
  }, [value]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.persist();
    setSearchTerm(e.target.value);
    onChange?.(e);
  };

  const handleOnClean = () => {
    setSearchTerm("");
    onClearSearch?.();
  };

  return (
    <div className="relative">
      <InputText
        name="search-input"
        startAdornment={<MagnifyingGlassIcon width={20} height={20} className="text-grey-400" />}
        endAdornment={
          searchTerm.length > 0 ? (
            <XIcon width={20} height={20} className="cursor-pointer text-grey-400" onClick={handleOnClean} />
          ) : undefined
        }
        value={searchTerm}
        className={cn("rounded-full", className)}
        onChange={handleOnChange}
        {...otherProps}
      />
    </div>
  );
};
